import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { useLanguage } from "../../Context/LanguageContext.jsx";
import navbarKeys from "../../myData/keys.js";
import website_logo from "../../assets/logos/logo.png";
import website_title from "../../assets/logos/amer_name.png";
import "../Navbar/navbar.css";
import {
  HiOutlineSortDescending,
  HiOutlineSortAscending,
} from "react-icons/hi";

function Navbar() {
  const [clickedKey, setClickedKey] = useState(null);
  const [chosenLanguage, setChosenLanguage] = useState("english");
  const { language, setLanguage, isNavbarOpen, setIsNavbarOpen } =
    useLanguage();

  const getNavbarKeyClass = (key) => {
    if (key === clickedKey) {
      return "navbar-key active-btn";
    } else {
      return "navbar-key";
    }
  };

  return (
    <div className="navbar-container">
      <div className="title-and-list">
        {isNavbarOpen ? (
          <HiOutlineSortAscending
            className="navbar-list-icon"
            onClick={() => setIsNavbarOpen(false)}
          />
        ) : (
          <HiOutlineSortDescending
            className="navbar-list-icon"
            onClick={() => setIsNavbarOpen(true)}
          />
        )}
        <NavLink
          to="/"
          className="website-title"
          onClick={() => setClickedKey(null)}
        >
          <div className="website-logo">
            <img src={website_logo} alt="website logo" />
            <img src={website_title} alt="website title" />
          </div>
        </NavLink>
      </div>
      <div className="navbar-keys">
        {navbarKeys[language].map((key, index) => (
          <NavLink
            key={index}
            to={`/${navbarKeys.english[index].toLowerCase()}`}
          >
            <button
              onClick={() => setClickedKey(index)}
              className={getNavbarKeyClass(index)}
            >
              {key === "extra-info" ? "Extra info" : key}
            </button>
          </NavLink>
        ))}
      </div>
      <div className="languages-buttons">
        {Object.keys(navbarKeys).map((language, index) => (
          <button
            className={
              chosenLanguage === language
                ? "language-btn active"
                : "language-btn"
            }
            key={index}
            onClick={() => {
              setLanguage(language);
              setChosenLanguage(language);
            }}
          >
            {language === "arabic"
              ? "عربي"
              : language === "dutch"
              ? "Nederlands"
              : language === "english"
              ? "English"
              : ""}
          </button>
        ))}
      </div>
    </div>
  );
}

export default Navbar;
